<style>
  .vid_side_box_inner {
  padding: 0 0 5px 0 !important;
  margin: 5px 0 0 !important;
  border-bottom: 1px solid #eee;
}
</style>
<div class="new-screen2">
  <div class="container">
    <div class="flex display-mob max-md:!flex-col md:flex-row md:gap-[20px]">
      <div class="max-md:!flex-[1_1_100%] md:flex-[1_1_33.33%] flex flex-col load-screen">
        <div class="flex flex-col internal3 one-section">
          <h5 class="all-head">{{featured.blog_category || ''}}</h5>
          @if (featured) {
            <div>
              <a [href]="featured.href_link" style="padding-bottom: 15px;">
                <div class="brdr-btm flex flex-col">
                  <div class="mrg-after-imgvid">
                    <img
                      loading="lazy"
                      [appImgFallback]="featured?.['image_url']"
                      imgContext="thumb"
                      alt="Feature from TheRightDoctors"
                      style="width: 100%"
                      />
                  </div>
                  <div class="flex flex-col">
                    <p class="internal-dr-name">{{ (featured.doctor && featured.doctor.name || '') }}</p>
                    <p class="internal-updates-head">{{ (featured.headline || '') | slice: 0:80 }}</p>
                  </div>
                </div>
              </a>
            </div>
          }

        </div>
      </div>

      <!-- screen 2 ends -->
      @if (overall) {
        <div class="max-md:!flex-[1_1_100%] md:flex-[1_1_40%] flex flex-col load-screen">
          <div class="flex flex-col">
            <div class="one-section one-section-des flex flex-col">
              <h5 class="all-head"><span class="circle red"></span>LIVE UPDATES</h5>
              @for (item of final_model; track item) {
                <a [routerLink]="item['category']">
                  <div class="live_updates flex flex-row gap-[8px]">
                    @if (item['image']) {
                      <div class="flex-[1_1_30%]">
                        <img loading="lazy" [src]="item['image']" alt="COVID 19" />
                      </div>
                    }
                    <div class="flex-[1_1_70%]">
                      <p class="internal-updates-head">
                        {{ item['title'] }}
                      </p>
                    </div>
                  </div>
                </a>
                <br />
              }
            </div>
          </div>
        </div>
      }

      @if (!overall) {
        <div class="max-md:!flex-[1_1_100%] md:flex-[1_1_40%] flex flex-col load-screen">
          <div class="flex flex-col">
            <h5 class="all-head">Story</h5>
            @if (top_storiesa && top_storiesa[5]) {
              <div>
                <a href="{{buildHrefLink(top_storiesa[5])}}" style="padding-bottom: 15px;">
                  <div class="brdr-btm flex flex-col">
                    <div class="mrg-after-imgvid">
                      <img loading="lazy" [appImgFallback]="top_storiesa[5]?.['image_url']" imgContext="thumb" alt="Feature from TheRightDoctors" style="width:100%">
                    </div>
                    <div class="flex flex-col">
                      <p class="internal-dr-name">{{(top_storiesa[5]?.['doctor'] && top_storiesa[5]?.['doctor']?.['name'] || '')}}</p>
                      <p class="internal-updates-head">{{(top_storiesa[5]?.['headline'] || '') | slice: 0 : 80}}</p>
                    </div>
                  </div>
                </a>
              </div>
            }
          </div>
        </div>
      }


      <div class="max-md:!flex-[1_1_100%] md:flex-[1_1_33.33%] flex flex-col load-screen">
        <div class="flex flex-col">
          <h5 class="all-head">streaming now</h5>
          <div class="brdr-btm flex flex-col">
            <div class="mrg-after-imgvid">
              @for (video of sources; track video) {
                <video preload="none" class="img-resp" (ended)="nextVideo()" style="width:100%" [poster]="liveUpdatesVideo?.['image_url'] | bestImage:'thumb'" controls>
                  <source [src]="video.src" type="video/mp4">
                </video>
              }
            </div>
            <a [href]="buildHrefLink(liveUpdatesVideo)" style="text-decoration:none;color:inherit;">
              <p class="internal-dr-name">{{liveUpdatesVideo['doctor'] && liveUpdatesVideo['doctor']?.['name'] || ''}}</p>
              <p class="internal-updates-head">{{liveUpdatesVideo['headline'] || ''}}</p>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
